import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import type PartnershipMessagingService from '@efdigital/ll-xceed-v2/services/partnership-messaging';
import { loadCoacheePartnershipConversations } from '@efdigital/ll-xceed-v2/utils/coaching/load-partnership-conversations';
import {
  type PartnershipConversation,
  sortConversationsByRecency,
} from '@efdigital/ll-xceed-v2/utils/coaching/partnership-messages';
import { cohortScopeKey } from '@efdigital/ll-xceed-v2/utils/coaching/scope-key';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoacheeCohortMessagesModel = {
  conversations: PartnershipConversation[];
  program_id: string;
  cohort_id: string;
};

export default class CoachingCoacheeCohortMessagesRoute extends Route<CoachingCoacheeCohortMessagesModel> {
  @service declare partnershipMessaging: PartnershipMessagingService;
  @service declare store: Store;

  async model(): Promise<CoachingCoacheeCohortMessagesModel> {
    const parent = this.modelFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortModel;
    const scopeKey = cohortScopeKey(parent.program_id, parent.cohort_id);

    // The parent cohort route's afterModel already synced this scope's
    // conversations — reuse them instead of fetching the same data again.
    const conversations =
      this.partnershipMessaging.role === 'coachee' &&
      this.partnershipMessaging.scopeKey === scopeKey &&
      this.partnershipMessaging.conversations.length
        ? this.partnershipMessaging.conversations
        : sortConversationsByRecency(
            await loadCoacheePartnershipConversations(
              this.store,
              parent.planner
            )
          );

    return {
      conversations,
      program_id: parent.program_id,
      cohort_id: parent.cohort_id,
    };
  }

  afterModel(model: CoachingCoacheeCohortMessagesModel): void {
    this.partnershipMessaging.sync(
      model.conversations,
      'coachee',
      cohortScopeKey(model.program_id, model.cohort_id)
    );
  }
}
